if (document.body.classList.contains('template-index')) {
    function CarouselFix() {
      let items = document.querySelectorAll(".jdgm-carousel__item-wrapper");
      items.forEach(item => {
        for (let i = 0; i < item.childElementCount; i++) {
          let image = item.children[i].querySelector(".jdgm-carousel-item__product-image");
          if (image) {
            image.setAttribute("height", "100px");
            image.setAttribute("width", "100px");
          }
        }
      });
    }
    if (document.readyState === "complete") {
      CarouselFix();
    } else {
      window.addEventListener("DOMContentLoaded", CarouselFix);
    }
}

document.addEventListener("DOMContentLoaded", function() {
    var picLinks = document.querySelectorAll('a.jdgm-rev__pic-link');
    if (picLinks) {
    picLinks.forEach(function(link) {
        link.setAttribute("role", "button");
        link.setAttribute("rel", "nofollow");
        link.setAttribute("aria-label", "Link to user picture");
    });
    }
});


function removeNofollowFromAnchors() {
    const anchors = document.querySelectorAll('.jdgm-rev__reply-content a');
    anchors.forEach((anchor) => {
    if (anchor.rel) {
        const relValues = anchor.rel.split(' ');
        const newRelValues = relValues.filter((value) => value !== 'nofollow');
        anchor.rel = newRelValues.join(' ');
    }
    });
}
if (document.readyState === "complete") {
    removeNofollowFromAnchors();
} else {
    window.addEventListener("DOMContentLoaded", removeNofollowFromAnchors);
}

if (document.body.classList.contains('page-subscribe')) {
  document.addEventListener("DOMContentLoaded", () => {
  const loader = document.querySelector("#subscribeloader");
  const form = document.querySelector(".klaviyo-form-X3chhN");

  if (!loader || !form) return; // Exit if elements are not found

  const interval = setInterval(() => {
    if (form.innerHTML.trim()) {
      loader.style.display = "none"; // Hide the loader
      clearInterval(interval); // Stop checking once content is found
    }
  }, 1000); // Check every second
 });
}